import React, { Component } from "react";
import { Redirect } from "react-router";
import { connect } from "react-redux";

import Background from "../../../../utils/Background/Background.component";
import PasswordCard from "./PasswordCard/PasswordCard.component";
import { authStoreSelectors } from "../../store/store";

export interface ResetPwdProps {
    redirectLogin: boolean;
}

class ResetPwdPage extends Component<ResetPwdProps, {}> {
    render() {
        return this.props.redirectLogin ?
            (<Redirect to="/login" />) : (
                <React.Fragment>
                    <Background />
                    <PasswordCard />
                </React.Fragment>
            )
    }
}

const mapStateToProps = state => ({
    redirectLogin: authStoreSelectors.redirectLogin(state)
});


export default connect(
    mapStateToProps,
)(ResetPwdPage);
